import cn from 'classnames';
import { ReactNode } from 'react';

import styles from './TwoColumnLayout.module.scss';

export type TwoColumnLayoutProps = {
  leftChildren?: ReactNode;
  rightChildren?: ReactNode;
  containerClassOverride?: string;
};

const TwoColumnLayout = (props: TwoColumnLayoutProps): JSX.Element => {
  const { leftChildren, rightChildren, containerClassOverride } = props;

  return (
    <div className={cn(styles.main, containerClassOverride || 'container-12')}>
      <div className={styles.left}>{leftChildren}</div>
      <div className={styles.right}>{rightChildren}</div>
    </div>
  );
};

export default TwoColumnLayout;
